/**
 * Created by Alex Aguilar on 7/29/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('addAirports', {
                parent: 'app',
                url: '/addAirports?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/addAirport/addAirports.html',
                        controller: 'addAirportsController',
                        controllerAs: 'vm',
                        resolve:{
                            'airports': ['airportService', '$stateParams', function (airportService, $stateParams) {
                                return airportService.getPageAirportsActiveDisable($stateParams.page, $stateParams.size, true, true);
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['airport']);
                            }]
                        }
                    }
                }
            })
            .state('addAirport', {
                parent: 'app',
                url: '/airport/add',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/addAirport/addAirport.html',
                        controller: 'addEditAirportController',
                        controllerAs: 'vm',
                        resolve: {
                            airport: [function() {
                                return null;
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['airport']);
                            }],
                            isEdit: [function() {
                                return false;
                            }]
                        }
                    }
                }
            })
            .state('addAirportEdit', {
                parent: 'app',
                url: '/addAirport/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/addAirport/addAirportEdit.html',
                        controller: 'addEditAirportController',
                        controllerAs: 'vm',
                        resolve: {
                            airport: ['$stateParams', 'airportService', function($stateParams, airportService) {
                                return airportService.getAirport($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['airport']);
                            }],
                            isEdit: [function() {
                                return true;
                            }]
                        }
                    }
                }
            })
            .state('addAirportDelete', {
                parent: 'addAirports',
                url: '/addAirport/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/addAirport/deleteAddAirport.html',
                        controller: 'deleteAddAirportController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'airport': ['airportService', function(airportService) {
                                return airportService.getAirport($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['airport']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('addAirports', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
